import _ from './button-icon.module.scss'
import React from 'react'

export const ButtonIcon = ({children}) => <span className={_.root}>{children}</span>
